import React, { useState, useEffect } from 'react';
import { api } from '../services/api';

export function TeamsPage() {
  const [teams, setTeams] = useState<any[]>([]);
  const [users, setUsers] = useState<any[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm] = useState({ name: '', description: '', color: '#3b82f6' });
  const [selectedTeam, setSelectedTeam] = useState<any>(null);

  useEffect(() => {
    api.get('/teams').then(r => setTeams(r.data));
    api.get('/users').then(r => setUsers(r.data));
  }, []);

  const createTeam = async (e: React.FormEvent) => {
    e.preventDefault();
    const { data } = await api.post('/teams', form);
    setTeams(prev => [...prev, { ...data, memberCount: 0, members: [] }]);
    setShowCreate(false);
    setForm({ name: '', description: '', color: '#3b82f6' });
  };

  const addMember = async (teamId: number, userId: number) => {
    await api.post(`/teams/${teamId}/members`, { userId });
    const { data } = await api.get('/teams');
    setTeams(data);
  };

  const removeMember = async (teamId: number, userId: number) => {
    await api.delete(`/teams/${teamId}/members/${userId}`);
    const { data } = await api.get('/teams');
    setTeams(data);
  };

  const COLORS = ['#3b82f6','#10b981','#f59e0b','#ef4444','#8b5cf6','#ec4899','#06b6d4','#84cc16'];

  return (
    <div style={{ padding: '28px 32px' }}>
      <div className="page-header">
        <div>
          <h1 className="page-title">Equipos</h1>
          <p className="page-subtitle">{teams.length} equipos · {users.length} empleados</p>
        </div>
        <button className="btn btn-primary" onClick={() => setShowCreate(true)}>+ Nuevo equipo</button>
      </div>

      {showCreate && (
        <div className="card" style={{ marginBottom: 20 }}>
          <h3 style={{ fontSize: 13, fontWeight: 700, marginBottom: 14 }}>Crear equipo</h3>
          <form onSubmit={createTeam} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <input className="input" placeholder="Nombre del equipo" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required />
            <input className="input" placeholder="Descripción (opcional)" value={form.description} onChange={e => setForm({...form, description: e.target.value})} />
            <div>
              <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 6 }}>Color</div>
              <div style={{ display: 'flex', gap: 8 }}>
                {COLORS.map(c => (
                  <div key={c} onClick={() => setForm({...form, color: c})} style={{
                    width: 24, height: 24, borderRadius: '50%', background: c, cursor: 'pointer',
                    border: form.color === c ? '2px solid white' : '2px solid transparent',
                  }} />
                ))}
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button type="submit" className="btn btn-primary">Crear</button>
              <button type="button" className="btn btn-secondary" onClick={() => setShowCreate(false)}>Cancelar</button>
            </div>
          </form>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 16 }}>
        {teams.map(team => (
          <div key={team.id} className="card" style={{ borderLeft: `3px solid ${team.color}` }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
              <div style={{ width: 10, height: 10, borderRadius: '50%', background: team.color }} />
              <div style={{ fontWeight: 700, fontSize: 14 }}>{team.name}</div>
              <span className="badge badge-gray" style={{ marginLeft: 'auto' }}>{team.memberCount} miembros</span>
            </div>
            {team.description && <p style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 12 }}>{team.description}</p>}
            
            {/* Members */}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 12 }}>
              {(team.members || []).map((m: any) => {
                const user = users.find(u => u.id === m.userId);
                return user ? (
                  <div key={m.userId} style={{ display: 'flex', alignItems: 'center', gap: 5, background: 'var(--bg3)', borderRadius: 20, padding: '3px 8px 3px 4px' }}>
                    <div style={{ width: 18, height: 18, borderRadius: '50%', background: 'var(--accent-dim)', color: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, fontWeight: 700 }}>
                      {user.name?.charAt(0)}
                    </div>
                    <span style={{ fontSize: 11 }}>{user.name}</span>
                    <button onClick={() => removeMember(team.id, m.userId)} style={{ background: 'none', border: 'none', color: 'var(--text3)', cursor: 'pointer', fontSize: 10, padding: 0 }}>×</button>
                  </div>
                ) : null;
              })}
            </div>

            {/* Add member */}
            <select className="input" style={{ fontSize: 11, padding: '4px 8px' }}
              onChange={e => { if (e.target.value) { addMember(team.id, +e.target.value); e.target.value = ''; } }}>
              <option value="">+ Añadir miembro</option>
              {users.filter(u => !(team.members || []).some((m: any) => m.userId === u.id)).map(u => (
                <option key={u.id} value={u.id}>{u.name}</option>
              ))}
            </select>
          </div>
        ))}
      </div>
    </div>
  );
}
